import React from 'react';
// import './Preloader.css'; 

const Preloader = () => {
  return (
    <div id="preloader">
      <div id="loader">
        <div id="loader-before"></div>
        <div id="loader-after"></div>
      </div>
    </div>
  );
};

export default Preloader;
